import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from 'avn/interfaces/homepage';
import { ApiService } from 'avn/services/api.service';
import { Constants } from 'avn/services/constants';
import { StoreService } from 'avn/services/store.service';
import { SharedCompsService } from 'avn/shared/shared-comps.service';
import { toUrlSlug } from 'avn/shared/utils/url-slug.util';

@Component({
  selector: 'app-category-provider-item',
  templateUrl: './category-provider-item.component.html',
  styleUrls: ['./category-provider-item.component.scss']
})
export class CategoryProviderItemComponent implements OnInit {
  @Input() provider: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: StoreService,
    private api: ApiService,
    private shared: SharedCompsService
  ) {}

  category: string;
  isSymptom = false;
  isSubCategoryPage = false;
  subCatObj: any = {};
  mainCategory = '';
  city: string;
  post_code: string;

  ngOnInit(): void {
    const params: any = { ...this.route.snapshot.params };
    this.isSubCategoryPage = this.checkIsSubCategoryPage(params.city);
    if (this.isSubCategoryPage) {
      params.parent_category = params.category_name;
      params.category_name = params.city;
      params.city = params.post_code;
    }
    if (!this.isSubCategoryPage && params.parent_category) {
      this.isSubCategoryPage = true;
      this.mainCategory = params.parent_category;
    }
    this.category = params.category_name;
    this.isSymptom = Constants.HEALTH_CONDITIONS.indexOf(this.category) > -1;

    this.city = toUrlSlug(this.provider.business_location.city);
    this.post_code = this.provider.business_location.postal_code;
    localStorage.removeItem('tempSlug');
  }

  getProviderImage() {
    if (this.provider.business_images.length > 0) {
      return this.provider.business_images[0].correct_image;
    }
    return this.provider.business_detail.correct_image;
  }

  checkIsSubCategoryPage(category: string) {
    const subCatObj = Constants.SUBCATEGORY_LIST;
    for (const key in subCatObj) {
      if (subCatObj[key].findIndex((x: any) => x.key === category) > -1) {
        this.mainCategory = key;
        return true;
      }
    }
    return false;
  }

  nearestDistance() {
    return (Math.round(this.provider.business_location.distance * 100) / 100).toFixed(1);
  }

  generateProviderUrl() {
    return ['/provider/' + this.provider.slug + '/' + toUrlSlug(this.provider?.business_location?.city)];
  }

  fetchBookingURL(service: any) {
    const business = service.slug;
    return this.shared.goToBooking({
      business,
      service: `${service.uuid}}a-`,
      prac: service.service_practitioner_detail?.[0]?.id,
      return: 'return'
    });
  }

  changeLocation() {
    const address = `${this.city}, ${this.post_code}`;
    const responseObs = this.api.getGeoCodingByAddress(address);
    responseObs.subscribe({
      next: (response) => {
        const prediction: any = {};
        let state = '';
        let city = '';
        try {
          let postcode = '';

          if (response.geocode_details.results[0].address_components) {
            for (let i = 0; i < response.geocode_details.results[0].address_components.length; i++) {
              const component = response.geocode_details.results[0].address_components[i];
              if (component.types[0] === 'postal_code') {
                postcode = component.long_name;
              } else if (component.types[0] === 'administrative_area_level_1') {
                state = component.long_name;
              } else if (
                component.types[0] === 'locality' ||
                (component.types.length > 2 && component.types[1] === 'locality') ||
                (component.types.length > 3 && component.types[2] === 'locality')
              )
                city = component.long_name;
            }
          }
          if (postcode === '') {
            postcode = this.setMajorCityAndSuburbInfo(city);
          }
          const lng = response.geocode_details.results[0].geometry.location.lng;
          const lat = response.geocode_details.results[0].geometry.location.lat;
          prediction.longitude = lng;
          prediction.latitude = lat;
        } catch (e) {
          console.info(e);
        }
        const loc = new Location();
        loc.lat = prediction.latitude;
        loc.lng = prediction.longitude;
        loc.post_code = prediction.postal_code || this.post_code;
        loc.city_name = city;
        loc.state_name = state;
        localStorage.setItem('meraLocation', JSON.stringify(loc));
        this.store.setmeraLocation(loc);
        const url = `/search/${this.isSymptom ? 'health-condition/' : ''}${
          this.isSubCategoryPage ? this.mainCategory + '/' : ''
        }${this.category}/${toUrlSlug(this.city)}/${this.post_code}`;
        this.router.navigate([url]);
      }
    });
  }

  setMajorCityAndSuburbInfo(suburb: string) {
    const mc = suburb.toLowerCase();
    if (mc === 'brisbane') {
      return '4000';
    } else if (mc === 'perth') {
      return '6000';
    } else if (mc === 'melbourne') {
      return '3000';
    } else if (mc === 'adelaide') {
      return '5000';
    } else if (mc === 'sydney') {
      return '2000';
    }
    return '';
  }
}
